import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VCardTitle,[_c('span',{staticClass:"text-h5 mb-4"},[_vm._v("Terms and conditions")])]),_c(VCardText,{staticClass:"content"},[_vm._v(_vm._s(_vm.terms))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }